import { render, staticRenderFns } from "./ShopGroupItem.vue?vue&type=template&id=6d0cabb9&scoped=true"
import script from "./ShopGroupItem.vue?vue&type=script&lang=js"
export * from "./ShopGroupItem.vue?vue&type=script&lang=js"
import style0 from "./ShopGroupItem.vue?vue&type=style&index=0&id=6d0cabb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0cabb9",
  null
  
)

export default component.exports